export default __webpack_public_path__ + "static/media/photo--sm--matt.566f6bfc.jpg";